import { useState } from 'react';
import PAIAH010 from '../../../pages/MyPage/PAIAH010';
import PAJAJ020 from '../../../pages/MyPage/PAJAJ020';

const withPassword = (Component) => {
    return (props) => {
        const [isAuthenticated, setIsAuthenticated] = useState(false);
        const pathname = window.location.pathname;

        const handleAuthentication = (status) => {
            setIsAuthenticated(status);
        };

        if (!isAuthenticated && pathname.startsWith('/PAI')) {
            return <PAIAH010 onAuthenticate={handleAuthentication} />;
        }

        if (!isAuthenticated && pathname.startsWith('/PAJ')) {
            return <PAJAJ020 onAuthenticate={handleAuthentication} />;
        }

        return <Component {...props} />;
    };
};

export default withPassword;
